import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import { H5 } from "../../../AbstractElements";
import useAxios from "../../../Utils/useAxios";
import DataTable from "react-data-table-component";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { toast } from "react-toastify";
import { admins } from "../../../Constant";
import { getUser } from "../../../Utils/externalFunctions";
import { Trash2, Edit } from "react-feather";
import { Link } from "react-router-dom";
import { filterBetweenDate, filterSearch } from "../../../Utils/FilterItems";
import { useThemeContext } from "../../../Context/ThemeContext";
import { getDarkInput } from "../../../Utils/otherFunctions";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";
import CollapseableCard from "../../../CommonElements/Collapse/CollapseableCard";
import getPengumumanList from "../services/getPengumuman";
import deletePengumuman from "../services/deletePengumuman";

const Announcement = (props) => {
  const axiosInstance = useAxios();
  const [selectedFilterTanggal, setSelectedFilterTanggal] = useState("");
  const [filterText, setFilterText] = useState("");
  const [pengumumanList, setPengumumanList] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [pending, setPending] = useState(true);
  const [modal, setModal] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const toggle = () => setModal(!modal);

  const { themeContext } = useThemeContext();

  let isMounted = true;
  useEffect(() => {
    refreshPengumumanList();

    return () => {
      isMounted = false;
    };
  }, []);

  const refreshPengumumanList = async () => {
    getPengumumanList(axiosInstance).then((response) => {
      if (isMounted && response.status === 200) {
        setPengumumanList(response.data);
        setPending(false);
      }
    });
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const handleDelete = (e, pk) => {
    e.preventDefault();
    deletePengumuman(axiosInstance, pk).then((response) => {
      getPengumumanList();
    });
  };

  const handleEdit = async (e, data) => {
    e.preventDefault();
    setEditingData(data);
    toggle();
  };

  const clearEditingData = () => {
    setEditingData(null);
  };

  const filterData = (data) => {
    const filteredData = data
      .filter(
        filterBetweenDate(
          "date_created",
          "date_modified",
          selectedFilterTanggal
        )
      )
      .filter(filterSearch(["title", "username"], filterText));
    return filteredData;
  };

  const getSubHeaderComponent = () => (
    <Col>
      <Row>
        <Col>
          <Form className="row pt-3">
            <FormGroup>
              <Input
                type="date"
                onChange={(e) => setSelectedFilterTanggal(e.target.value)}
              />
            </FormGroup>
          </Form>
        </Col>
        <Col className="d-inline-flex justify-content-end align-items-center">
          <FilterComponent
            onFilter={(e) => {
              let newFilterText = e.target.value;
              setFilterText(newFilterText);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        </Col>
      </Row>
    </Col>
  );

  const ExpandedComponent = ({ data }) => (
    <div className="p-15">{data.description}</div>
  );

  const DaftarColumns = [
    {
      name: <DataTableTitle text={"Judul"} />,
      selector: (row) => row.title,
      width: "30%",
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Dibuat"} />,
      selector: (row) => row.date_created,
      sortable: true,
      wrap: true,
      sortFunction: DateSortFunction("date_created"),
    },
  ];

  if (admins.includes(getUser())) {
    DaftarColumns.push({
      name: <DataTableTitle text={"Operasi"} />,
      selector: (row) => (
        <>
          <Link onClick={(e) => handleEdit(e, row)}>
            <Edit color="orange" />
          </Link>
          <Link
            style={{ marginLeft: "20px" }}
            onClick={(e) => handleDelete(e, row.id)}
          >
            <Trash2 color="red" />
          </Link>
        </>
      ),
      sortable: true,
      wrap: true,
    });
  }

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={"Pengumuman"}>
          <div className="text-end">
            <ModalPengumuman
              axiosInstance={axiosInstance}
              getPengumumanList={getPengumumanList}
              modal={modal}
              toggle={toggle}
              editingData={editingData}
              clearEditingData={clearEditingData}
            />
          </div>
          <DataTable
            columns={DaftarColumns}
            data={filterData(pengumumanList)}
            pagination
            paginationResetDefaultPage={resetPaginationToggle}
            fixedHeader
            fixedHeaderScrollHeight="360px"
            dense
            highlightOnHover
            subHeader
            subHeaderComponent={getSubHeaderComponent()}
            expandableRows
            expandableRowsComponent={ExpandedComponent}
            subHeaderAlign="right"
            persistTableHead
            progressPending={pending}
            theme={themeContext}
          />
        </CollapseableCard>
      </Col>
    </Fragment>
  );
};

function ModalPengumuman(args) {
  const {
    toggle,
    modal,
    editingData,
    clearEditingData,
    axiosInstance,
    getPengumumanList,
  } = args;
  const [formData, setFormData] = useState({});

  const { themeContext } = useThemeContext();

  useEffect(() => {
    if (editingData !== null) {
      setFormData(editingData);
      clearEditingData();
    }
    if (!modal) {
      setFormData({});
    }
  }, [modal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!(formData.title && formData.description)) {
      toast.warning("Masukan Data Dengan Benar", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (formData.id !== undefined) {
      await axiosInstance
        .put(`pengumuman/${formData.id}`, formData)
        .then(function (response) {
          if (response.status === 200) {
            toast.success("Data successfully Updated!", {
              position: toast.POSITION.TOP_RIGHT,
            });
            toggle();
            setFormData({});
            getPengumumanList();
          }
        })
        .catch(function (error) {
          toast.error(`${error}`, {
            position: toast.POSITION.TOP_RIGHT,
          });
          console.log(error);
        });
    } else {
      await await axiosInstance
        .post("pengumuman/", formData)
        .then(function (response) {
          if (response.status === 201) {
            toast.success("Data successfully Sent!", {
              position: toast.POSITION.TOP_RIGHT,
            });
            toggle();
            setFormData({});
            getPengumumanList();
          }
        })
        .catch(function (error) {
          toast.error(`${error}`, {
            position: toast.POSITION.TOP_RIGHT,
          });
          console.log(error);
        });
    }
  };

  return (
    <div>
      {admins.includes(getUser()) && (
        <Button color="success" onClick={toggle}>
          Buat Pengumuman
        </Button>
      )}

      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <ModalHeader toggle={toggle}>Buat Pengumuman</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="title">Judul</Label>
              <Input
                className={getDarkInput(themeContext)}
                type="text"
                name="title"
                id="title"
                placeholder="Masukan Judul"
                defaultValue={formData.title}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="description">Deskripsi</Label>
              <Input
                className={getDarkInput(themeContext)}
                type="textarea"
                name="description"
                id="description"
                placeholder="Masukan Deskripsi"
                defaultValue={formData.description}
                onChange={handleChange}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Submit
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Announcement;
